import { render, staticRenderFns } from "./return.modal.vue?vue&type=template&id=63d59cb4"
import script from "./return.modal.vue?vue&type=script&lang=js"
export * from "./return.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports